( function( $ ) {

  setTimeout(function() {
    $(".block-face-page").append('<div class="fb-page" data-href="https://www.facebook.com/Jurado-Jurado-Advogados-270770919621799/" data-width="470px" data-height="304" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true" data-show-posts="true"><div class="fb-xfbml-parse-ignore"><blockquote cite="https://www.facebook.com/Jurado-Jurado-Advogados-270770919621799/"><a href="https://www.facebook.com/Jurado-Jurado-Advogados-270770919621799/">Jurado & Jurado</a></blockquote></div></div>');
    FB.XFBML.parse();
  }, 10000);

})( jQuery );
